import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-warehouse-goods-report",
  templateUrl: "./warehouse-goods-report.component.html",
  styleUrls: ["./warehouse-goods-report.component.scss"],
})
export class WarehouseGoodsReportComponent extends BaseListComponent {
  WarehouseGoodsColumns: form_control[] = [];
  constructor() {
    super();
  }
  ngOnInit() {
    this.setColumns().then();
    this.label = "گزارش ارتباط کالا و انبار";
    this.apiName = "Warehouse/WarehouseGoodsReport";
    this.areaName = "Inventory";
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  async setColumns() {
    await this.httpCommonService
      .get("Warehouse/GetWarehouseGoodsFormulaInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.WarehouseGoodsColumns = data as form_control[];
            this.WarehouseGoodsColumns = this.WarehouseGoodsColumns.sort((a, b) => a.order - b.order);
            this.WarehouseGoodsColumns.forEach((x) => {
              if (x.name === "WarehouseCode" || x.name === "WarehouseTitle" || x.name === "GoodsCode" || x.name === "GoodsTitle")
                x.listVisible = true;
              else x.listVisible = false;
            });
          }
        },
        (error) => console.log(error)
      );
  }
}
